import Vue from 'vue'
import VueI18n from 'vue-i18n'


Vue.use(VueI18n)

const localeMessages = {}
const dateTimeFormats = {}

const locales = require.context('../locales', true, /[a-z0-9]+\.json$/i)
locales.keys().forEach(key => {
    const matched = key.match(/([a-z0-9]+)\./i)
    if (matched && matched.length > 1) {
        localeMessages[matched[1]] = locales(key)
        dateTimeFormats[matched[1]] = {
            short: {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            },
            long: {
                weekday: 'long',
                day: 'numeric',
                month: 'long'
            },
            month: {
                year: 'numeric',
                month: 'long'
            },
            weekday: {
                weekday: 'long'
            },
            monthName: {
                month: 'long'
            }
        }
    }
})

export default new VueI18n({
    locale: navigator.language.substring(0, 2),
    fallbackLocale: 'en',
    messages: localeMessages,
    dateTimeFormats: dateTimeFormats
})
